import { useContext } from "react";
import { BooleanField, Datagrid, List, TextField, TextInput } from "react-admin"
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const InstitutionBranchList = (props) => {

    const context = useContext(AppContext)

    const filter = [
        <TextInput source="institution" label='Instituição' alwaysOn />,
        <TextInput source='name' label='Unidade' alwaysOn />,
    ]


    return (
        <List bulkActionButtons={false} filters={filter} sort={{ field: 'institution.name', order: 'ASC' }}  {...props}>
            <Datagrid rowClick={context.profile.name === ProfileEnum.SUPERADMIN ? 'edit' : 'show'}>
                <TextField source="institution.name" label={'Instituição'} />
                <TextField source="name" label={'Unidade'} />
                <BooleanField source="active" label={'Ativo'} />
            </Datagrid>
        </List>
    )
}

export default InstitutionBranchList;